/**
 * 付费会员（付费等级）相关的展示文案和取数。
 *
 * 用户列表接口和用户详情接口带的关联不一样：详情带了 paidLevelInfo，
 * 列表只有 payLevelId / paidExpireTime / paidIsExpire 这几个字段，
 * 拿不到等级名。所以列表那边用 payLevelId 去等级列表里查名字，见 getPaidLevelList。
 */

import dayjs from "dayjs";
import { request } from "@/plugins/api/index";

let levelPromise: any = null;

/**
 * 付费会员等级列表。用户列表只要 id→名字，赠送弹窗还要拿它当选项，
 * 两边共用一份，同一次会话里缓存住 —— 缓存写法同 store 模块的 getExpress：失败不缓存
 */
export async function getPaidLevelList() {
  if (levelPromise) {
    let { error } = await levelPromise;
    if (!error) return levelPromise;
  }
  levelPromise = request.$post("/manager/level/paid-list", { pageSize: -1 });
  return levelPromise;
}

/**
 * 付费会员展示文案。
 *
 * 到期与否优先用后端的 paidIsExpire，口径和它一致：没等级、没到期时间、已超过到期时间都算已过期。
 * 等级名优先用传进来的（列表接口没带 paidLevelInfo，得靠调用方查），
 * 其次用关联上的，都没有又确实有等级时退化成「付费会员」。
 */
export function getPaidVipText(row: any, levelName?: string) {
  let name = levelName || (row?.paidLevelInfo && row.paidLevelInfo.name) || (row?.payLevelId ? "付费会员" : "");
  if (!name) return "--";
  let expire = row?.paidExpireTime;
  let isExpire = row?.paidIsExpire ?? (!expire || new Date(expire).valueOf() < Date.now());
  if (isExpire) {
    return expire ? `${name}（已过期 ${dayjs(expire).format("YYYY-MM-DD")}）` : `${name}（已过期）`;
  }
  return `${name}（ ${dayjs(expire).format("YYYY-MM-DD")}）`;
}
